export default "__VITE_ASSET__DNpoVKKv__"